import React from 'react';
import { Link } from '../Links';

export interface CengagePhoneHelpProps {}
export const CengagePhoneHelp: React.FC<CengagePhoneHelpProps> = () => {
  return <Link href={window?.backend?.cengagePhoneHelpUrl} target="_blank">contact support</Link>;
};
